// src/components/Admin/RutasDidacticasComp/RutasDidacticasEditWizard.js
import React, { useState } from "react";
import { Step, Modal } from "semantic-ui-react";
import { Modal as AntModal, Steps } from "antd";
import { useTranslation } from "react-i18next";
import { RutasDidacticasEditStep1, RutasDidacticasEditStep2 } from "./index";
import { RutasDidacticasFormStep3Share } from "../RutasDidacticasForm/RutasDidacticasFormStep3Share";
import { BrandThemeProvider } from "../../../../ui";
import { NEW_SALAS } from "../../../../ui/featureFlags";
import "./RutasDidacticasWizardedit.scss";

export function RutasDidacticasEditWizard({
  open,
  onClose,
  route,
  accessToken,
  onRefresh,
  teacher,
}) {
  const { t } = useTranslation("itineraries");
  const [activeStep, setActiveStep] = useState(1);
  // Estado local con los cambios hechos en Step1 (sin persistir aún)
  const [updatedRoute, setUpdatedRoute] = useState(route);

  const steps = [
    {
      key: "editData",
      title: t("wizard.editDataStep"),
      icon: "edit",
      active: activeStep === 1,
    },
    {
      key: "editAssistants",
      title: t("wizard.editAssistantsStep"),
      icon: "users",
      active: activeStep === 2,
    },
    {
      key: "share",
      title: t("wizard.editShareStep"),
      icon: "share",
      active: activeStep === 3,
    },
  ];

  const goNext = () => setActiveStep((prev) => Math.min(prev + 1, 3));
  const goBack = () => setActiveStep((prev) => Math.max(prev - 1, 1));

  const renderContent = () => {
    if (!updatedRoute) {
      return <div style={{ padding: "1rem" }}>{t("editWizard.loading")}</div>;
    }

    switch (activeStep) {
      case 1:
        return (
          <RutasDidacticasEditStep1
            route={updatedRoute}
            teacher={teacher}
            onUpdateRoute={(newData) =>
              setUpdatedRoute((prev) => ({ ...prev, ...newData }))
            }
            onClose={onClose}
            onNext={goNext} // pasa al paso 2
          />
        );
      case 2:
        return (
          <RutasDidacticasEditStep2
            route={updatedRoute}
            accessToken={accessToken}
            onRefresh={onRefresh}
            onClose={onClose}
            onBack={goBack}
            onNext={() => setActiveStep(3)} // pasa al paso 3
          />
        );
      case 3:
        return (
          <RutasDidacticasFormStep3Share
            accessToken={accessToken}
            teacher={teacher}
            route={updatedRoute}
            onReload={onRefresh}
            onClose={onClose} // al guardar/terminar, cierra el modal
          />
        );
      default:
        return null;
    }
  };

  if (NEW_SALAS) {
    return (
      <BrandThemeProvider>
        <AntModal
          open={open}
          onCancel={onClose}
          footer={null}
          width={760}
          destroyOnHidden
          maskClosable={false}
          className="rutas-wizard-modal"
        >
          <div className="rutas-wizard">
            <Steps
              current={activeStep - 1}
              items={[
                { title: t("wizard.editDataStep") },
                { title: t("wizard.editAssistantsStep") },
                { title: t("wizard.editShareStep") },
              ]}
              style={{ marginBottom: 18 }}
            />
            {renderContent()}
          </div>
        </AntModal>
      </BrandThemeProvider>
    );
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="large"
      closeIcon
      className="rutas-edit-wizard"
    >
      <div className="wizard-step-group">
        <Step.Group ordered items={steps} activeIndex={activeStep - 1} />
      </div>
      {renderContent()}
    </Modal>
  );
}
